(function ($) {
  $(document).ready(function ($) {
    if ($('body.index').length) {
      console.log('Index Home JS');

      // add scrolltrigger plugin
      gsap.registerPlugin(ScrollTrigger);

      // Responsive
      // ---
      ScrollTrigger.matchMedia({
        // large
        '(min-width: 950px)': function () {},
        // all
        all: function () {
          // ScrollTriggers created here aren't associated with a particular media query,
          // so they persist.

          // Home Hero Slider
          // ---
          var $heroSlider = $('.index__hero .owl-carousel');
          $heroSlider
            .owlCarousel({
              autoplay: false,
              items: 1,
              singleItem: true,
              rewind: true,
              rewindNav: true,
              rewindSpeed: 0,
              nav: true,
              dots: false,
              navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
              ],
              responsive: {
                950: {
                  mouseDrag: false,
                },
              },
            })
            .on('changed.owl.carousel', function (event) {
              var slides = $('.index__hero .right').children();
              $(slides).removeClass('active');
              $(slides[event.item.index]).addClass('active');
            });
          // ---
          // END Home Hero Slider

          // Index Intro Section
          // ---

          var $iconSlider = $('.index__intro .owl-carousel');
          $iconSlider.owlCarousel({
            lazyLoad: true,
            autoWidth: true,
            items: 1,
            singleItem: true,
            nav: false,
            dots: false,
            center: true,
            loop: true,
          });

          $iconSlider.on('changed.owl.carousel', function (event) {
            // Get the relative index of the centered item within the loop
            var centeredItemIndex =
              event.item.index -
              $(event.target).find('.owl-item.cloned').length / 2;
            var totalItems = $(event.target)
              .find('.owl-item')
              .not('.cloned').length;
            centeredItemIndex = centeredItemIndex % totalItems; // Normalize the index if it's negative or exceeds the total items

            var imageryWrap = $('.type-imagery').children();
            var mobileTitles = $('.mobile-type-titles').children();
            console.log('Centered item index:', centeredItemIndex);
            $(imageryWrap).removeClass('active');
            $(mobileTitles).removeClass('active');
            $(imageryWrap[centeredItemIndex]).addClass('active');
            $(mobileTitles[centeredItemIndex]).addClass('active');
          });

          /*
          $('.desktop-icons button.icon').click(function (e) {
            var i = $(this).index();
            var titles = $('.type-titles').children();
            var imgs = $('.type-imagery').children();

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            $(titles).removeClass('active');
            $(imgs).removeClass('active');

            $(titles[i]).addClass('active');
            $(imgs[i]).addClass('active');
          });*/
          $('.desktop-icons button.icon').hover(
            function (e) {
              // Mouse Enter
              var i = $(this).index();
              var titles = $('.type-titles').children();
              var imgs = $('.type-imagery').children();

              $(this).siblings().removeClass('active');
              $(this).addClass('active');

              $(titles).removeClass('active');
              $(imgs).removeClass('active');

              $(titles[i]).addClass('active');
              $(imgs[i]).addClass('active');
            },
            function (e) {
              // Mouse Leave
              // You can define what should happen when the mouse leaves.
            }
          );

          // ---
          // END Index Intro Section

          // Featured Stories / Blogs Slider
          // ---
          var $storySlider = $('.index__featured-stories .owl-carousel');
          $storySlider.owlCarousel({
            lazyLoad: true,
            autoWidth: true,
            items: 1,
            nav: false,
            dots: false,
            responsive: {
              767: {
                items: 3,
              },
            },
          });
          $('.index__featured-stories button.prev').click(function (e) {
            console.log('prev');
            $storySlider.trigger('prev.owl.carousel');
          });
          $('.index__featured-stories button.next').click(function (e) {
            console.log('next');
            $storySlider.trigger('next.owl.carousel');
          });
          // ---
          // END Featured Stories / Blogs Slider

          // Featured Media Quotes Slider
          // ---
          var $quoteSlider = $(
            '.index__featured-media .media-quotes.owl-carousel'
          );
          $quoteSlider.owlCarousel({
            lazyLoad: true,
            loop: true,
            items: 1,
            nav: false,
            dots: false,
            rewind: true,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true,
          });

          var $logoSlider = $(
            '.index__featured-media .media-logos.owl-carousel'
          );
          $logoSlider.owlCarousel({
            lazyLoad: true,
            loop: true,
            autoWidth: true,
            items: 1,
            nav: false,
            dots: false,
            rewind: true,
            mouseDrag: false,
            touchDrag: false,
          });

          var loadingBarTimeline = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.5,
          });

          loadingBarTimeline.set('.bar-inner', { width: '0%' });
          loadingBarTimeline.to('.bar-inner', {
            width: '100%',
            duration: 8.5,
            ease: 'linear',
            onComplete: function () {
              $quoteSlider.trigger('next.owl.carousel');
              $logoSlider.trigger('next.owl.carousel');
            },
          });
          // ---
          // END Featured Media Quotes Slider

          // Testimonials Section
          //    – button click toggles to next testimonial
          // ---
          $('.testimonial-next').click(function () {
            var currentActive = $('.testi.active');
            var nextActive = currentActive.next('.testi');

            // Updating aria-hidden attribute for current active and all other testimonials
            currentActive.attr('aria-hidden', 'true').removeClass('active');
            $('.testi').attr('aria-hidden', 'true');

            // If there's a next sibling with class "testi"
            if (nextActive.length) {
              nextActive.attr('aria-hidden', 'false').addClass('active');
            } else {
              // If it's the last .testi, then add the active class to the first
              $('.testi')
                .first()
                .attr('aria-hidden', 'false')
                .addClass('active');
            }
          });
          // ---
          // END Testimonials Section
        },
      });
      // ---
      // END Responsive
    }
  });
})(jQuery);
